module.exports = __webpack_public_path__ + "img/dmitiri.613a6961.png";